<template>
  <Modal :title="$t('global.oops')" @close="close" @confirm="confirm">
    <template #body>
      <div>{{ $t("global.premium-feature-notice") }}</div>
    </template>
    <template #footer>
      <Btn class="mr-2" variant="light" type="button" @click="close">
        {{ $t("global.cancel") }}
      </Btn>
      <Btn variant="primary" @click="confirm">
        {{ $t("global.upgrade") }}
      </Btn>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import FreeTrialPlanUpgradeModal from "@/components/smart/modals/FreeTrialPlanUpgrade";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "FreeTrialPayWallModal",
  components: {
    Modal,
    Btn,
  },
  props: {
    data: {
      type: Object,
      validator: (value) => {
        const hasPackage = !!value.package && typeof value.package === "object";
        const hasPlan = !!value.plan && typeof value.plan === "object";
        const hasApp = !!value.app && typeof value.app === "object";

        return hasPackage && hasPlan && hasApp;
      },
    },
  },
  setup(props, { emit }) {
    const close = () => {
      emit("close");
    };

    const confirm = () => {
      emit("confirm");
      store.dispatch("modals/open", {
        template: FreeTrialPlanUpgradeModal,
        data: {
          package: props.data.package,
          plan: props.data.plan,
          app: props.data.app,
        },
      });
    };

    return { close, confirm };
  },
};
</script>
